<!-- Entity Selection Dialog -->
<div *ngIf="displayEntitySelectionDialog_add">
  <p-dialog
    [header]="header"
    [modal]="true"
    [(visible)]="displayEntitySelectionDialog_add"
    [style]="{ width: '80%' }"
    appendTo="body"
  >
    <jml-lib-dynamic-table
      *ngIf="entitySelectionTableData"
      [tableData]="entitySelectionTableData"
      (entitySelection)="entitySelected_add($event, attributeForm)"
      [isRootEntity]="false"
    ></jml-lib-dynamic-table>
  </p-dialog>
</div>

<div *ngIf="displayEntitySelectionDialog_update">
  <p-dialog
    [header]="header"
    [modal]="true"
    [(visible)]="displayEntitySelectionDialog_update"
    [style]="{ width: '80%' }"
    appendTo="body"
  >
    <jml-lib-dynamic-table
      *ngIf="entitySelectionTableData"
      [tableData]="entitySelectionTableData"
      (entitySelection)="entitySelected_update($event, attributeForm)"
      [isRootEntity]="false"
    ></jml-lib-dynamic-table>
  </p-dialog>
</div>

<!-- Add Attribute dialog -->
<p-dialog
  [header]="'Attribut ' + (dialogUpdate ? 'bearbeiten' : 'hinzufügen')"
  [modal]="true"
  [(visible)]="displayAddAttribute"
  [resizable]="false"
  [style]="{ width: '400px' }"
>
  <form
    (ngSubmit)="dialogUpdate ? updateAttribute() : addNewAttribute(); attributeForm.reset()"
    #attributeForm="ngForm"
  >
    <div class="form-group">
      <!-- Attribute Name  -->
      <span class="p-float-label mb-5">
        <input
          required
          name="Name"
          id="float-input"
          type="text"
          [(ngModel)]="dialogAttribute.name"
          class="w-full"
          pInputText
        />
        <label for="float-input">Name</label>
      </span>

      <!-- Type -->
      <span class="p-float-label mb-5">
        <p-dropdown
          required
          [options]="types"
          name="Typ"
          [style]="{ width: '100%' }"
          [panelStyle]="{ 'max-width': '368px' }"
          [(ngModel)]="dialogAttribute.attributeType"
          [autoDisplayFirst]="false"
          appendTo="body"
          [disabled]="dialogUpdate"
        ></p-dropdown>
        <label for="float-input">Typ</label>
      </span>

      <ng-container [ngSwitch]="dialogAttribute.attributeType">
        <!-- Reference -->
        <div *ngSwitchCase="'Reference'">
          <span class="p-float-label">
            <p-dropdown
              required
              [options]="dtoConfigs"
              name="DTOType"
              [style]="{ width: '100%' }"
              [panelStyle]="{ 'max-width': '368px' }"
              [(ngModel)]="dialogAttribute.referenceType"
              [autoDisplayFirst]="false"
              appendTo="body"
              (onChange)="refDtoRepr = ''; dialogAttribute.referenceId = undefined"
            ></p-dropdown>
            <label for="float-input">Objekttyp</label>
          </span>

          <span class="input-field p-inputgroup flex">
            <span class="p-float-label">
              <input
                name="Wert"
                [readonly]="true"
                id="float-input"
                (click)="openEntitySelectionDialog_add(dialogAttribute.referenceType)"
                (keyup.Space)="openEntitySelectionDialog_add(dialogAttribute.referenceType)"
                [(ngModel)]="dialogAttribute.value"
                pInputText
              />
              <label for="float-input">{{ displayNameFromType(dialogAttribute.referenceType) }}</label>
            </span>
            <button
              pButton
              [disabled]="!dialogAttribute.referenceType"
              type="button"
              (click)="openEntitySelectionDialog_add(dialogAttribute.referenceType)"
              icon="pi pi-pencil"
            ></button>
          </span>
        </div>

        <!-- Multiline -->
        <span class="input-field p-inputgroup flex" *ngSwitchCase="'Multiline'">
          <span class="p-float-label">
            <input
              #multilineInput
              id="float-input"
              readonly
              type="text"
              class="w-full cursor-pointer"
              (keyup.Space)="openMultilineEditor(multilineInput)"
              [ngModelOptions]="{ standalone: true }"
              [ngModel]="filterTags(dialogAttribute.stringValue)"
              (click)="openMultilineEditor(multilineInput)"
              pInputText
            />
            <label for="float-input">Wert</label>
          </span>
          <button pButton type="button" (click)="openMultilineEditor(multilineInput)" icon="pi pi-pencil"></button>
        </span>

        <!-- Integer -->
        <span class="p-float-label input-field" *ngSwitchCase="'Integer'">
          <input
            name="Wert"
            id="float-input"
            type="number"
            [(ngModel)]="dialogAttribute.longValue"
            class="w-full"
            pInputText
          />
          <label for="float-input">Wert</label>
        </span>

        <!-- Float -->
        <span class="p-float-label input-field" *ngSwitchCase="'Float'">
          <p-inputNumber
            name="Wert"
            id="float-input"
            mode="decimal"
            [(ngModel)]="dialogAttribute.floatValue"
            locale="de-DE"
            [minFractionDigits]="0"
            [maxFractionDigits]="16"
            class="w-full"
            [styleClass]="'input-full-width'"
          ></p-inputNumber>
          <label for="float-input">Wert</label>
        </span>

        <!-- Currency -->
        <div *ngSwitchCase="'Currency'" class="input-field">
          <jml-lib-currency-control
            name="Wert"
            placeholder="Wert"
            [float]="true"
            [(ngModel)]="dialogAttribute.longValue"
          ></jml-lib-currency-control>
        </div>

        <!-- Boolean -->
        <span class="p-float-label input-field flex" style="height: 34.5px" *ngSwitchCase="'Boolean'">
          <p-checkbox name="Wert" binary="true" class="pl-2" [(ngModel)]="dialogAttribute.booleanValue"></p-checkbox>
          <label for="float-input" style="top: -0.75em; font-size: 12px">Wert</label>
        </span>

        <!-- Date -->
        <span class="p-float-label input-field" *ngSwitchCase="'Date'">
          <p-calendar
            name="Wert"
            [locale]="de"
            [(ngModel)]="dialogAttribute.dateValue"
            dateFormat="dd.mm.yy"
            [inputStyle]="{ width: '100%' }"
            [style]="{ width: '100%' }"
            [showIcon]="true"
            appendTo="body"
          >
          </p-calendar>
          <label for="float-input">Datum</label>
        </span>

        <!-- DateTime -->
        <span class="p-float-label input-field" *ngSwitchCase="'DateTime'">
          <p-calendar
            name="Wert"
            [locale]="de"
            [(ngModel)]="dialogAttribute.dateValue"
            showTime="true"
            dateFormat="dd.mm.yy"
            [inputStyle]="{ width: '100%' }"
            [style]="{ width: '100%' }"
            [showIcon]="true"
            appendTo="body"
          >
          </p-calendar>
          <label for="float-input">Datum und Zeit</label>
        </span>

        <!-- Color -->
        <span class="p-float-label input-field" *ngSwitchCase="'Color'">
          <div>
            <p-colorPicker name="Wert" [(ngModel)]="dialogAttribute.stringValue"></p-colorPicker>
            <input
              name="Wert"
              pattern="^#([a-fA-F0-9]{6})$"
              id="float-input"
              type="text"
              [(ngModel)]="dialogAttribute.stringValue"
              style="width: 92%"
              pInputText
            />
          </div>
          <!--label for="float-input">Color</label-->
        </span>

        <!-- Icon -->
        <div class="p-float-label p-inputgroup input-field" *ngSwitchCase="'Icon'">
          <input
            name="Wert"
            [(ngModel)]="dialogAttribute.stringValue"
            type="text"
            class="w-full"
            pInputText
            [iconPicker]="icon"
            [ipIconPack]="['fa']"
            (iconPickerSelect)="onIconPickedAdd($event)"
          />
          <label for="float-input">Icon</label>
        </div>

        <!-- String -->
        <span class="p-float-label input-field" *ngSwitchDefault>
          <input
            name="Wert"
            id="float-input"
            type="text"
            [(ngModel)]="dialogAttribute.stringValue"
            class="w-full"
            pInputText
          />
          <label for="float-input">Wert</label>
        </span>
      </ng-container>

      <div class="p-0">
        <p-button
          type="submit"
          [disabled]="!attributeForm.form.valid"
          icon="pi pi-check"
          iconPos="left"
          [label]="dialogUpdate ? 'Speichern' : 'Erstellen'"
        ></p-button>
      </div>
    </div>
  </form>
</p-dialog>

<!-- Attributes -->
<p-table
  #table
  [value]="attributes"
  dataKey="id"
  styleClass="p-datatable-striped p-datatable-gridlines"
  jmlLibInitCallback
  (init)="afterTableInit()"
>
  <ng-template pTemplate="header">
    <tr class="header-style">
      <th style="width: 20%">Name</th>
      <th style="width: 20%">Typ</th>
      <th style="width: calc(60% - 6.5rem)">Wert</th>
      <th style="width: 6.5rem">
        <button pButton type="button" icon="pi pi-plus" (click)="openAttributeDialog()" pTooltip="Hinzufügen"></button>
        <button
          pButton
          type="button"
          icon="pi pi-refresh"
          style="float: right"
          (click)="updateAttributes()"
          pTooltip="Ansicht aktualisieren"
        ></button>
      </th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-ri="rowIndex">
    <tr [pSelectableRow]="rowData" [jmlVar]="{ isEdited: false }" #typeCell="jmlVar">
      <td id="hoverEffect">
        <div class="flex justify-content-center flex-column" style="min-height: 2.25rem">
          <jml-lib-string-cell
            (completeCellEdit)="onRowEditSave(rowData, null)"
            fieldName="name"
            [rowData]="rowData"
          ></jml-lib-string-cell>
        </div>
      </td>
      <td>
        {{ rowData.attributeType !== 'Reference' ? rowData.attributeType : displayNameFromType(rowData.referenceType) }}
      </td>
      <td id="hoverEffect" style="position: relative">
        <ng-container [ngSwitch]="rowData.attributeType">
          <jml-lib-string-cell
            *ngSwitchCase="'String'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="stringValue"
            [rowData]="rowData"
          ></jml-lib-string-cell>
          <jml-lib-integer-cell
            *ngSwitchCase="'Integer'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="longValue"
            [rowData]="rowData"
          ></jml-lib-integer-cell>
          <jml-lib-float-cell
            *ngSwitchCase="'Float'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="floatValue"
            [rowData]="rowData"
            [decimals]="16"
          ></jml-lib-float-cell>
          <jml-lib-bool-cell
            *ngSwitchCase="'Boolean'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="booleanValue"
            [rowData]="rowData"
          ></jml-lib-bool-cell>
          <jml-lib-currency-cell
            *ngSwitchCase="'Currency'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="longValue"
            [rowData]="rowData"
            [currency]="currency"
          ></jml-lib-currency-cell>
          <jml-lib-multiline-cell
            *ngSwitchCase="'Multiline'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="stringValue"
            [rowData]="rowData"
            [header]="'Attribut ' + rowData['name']"
          ></jml-lib-multiline-cell>
          <jml-lib-color-cell
            *ngSwitchCase="'Color'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="stringValue"
            [rowData]="rowData"
          ></jml-lib-color-cell>
          <jml-lib-icon-picker-cell
            *ngSwitchCase="'Icon'"
            (completeCellEdit)="onRowEditSave(rowData, typeCell)"
            fieldName="stringValue"
            [rowData]="rowData"
          ></jml-lib-icon-picker-cell>
          <ng-container *ngSwitchDefault>
            <jml-lib-entity-reference-cell
              *ngIf="rowData.attributeType === 'Reference' && rowData.referenceType !== 'CatalogueEntry'"
              (completeCellEdit)="onRowEditSave(rowData, typeCell, $event)"
              [dialogHeader]="rowData['name'] + ' auswählen'"
              [field]="rowData"
              fieldName="attribute"
              [dtoType]="rowData.referenceType"
              [rowData]="{ attribute: { _repr_: rowData['value'], id: rowData.referenceId } }"
            ></jml-lib-entity-reference-cell>
            <jml-lib-date-cell
              *ngIf="rowData.attributeType === 'Date' || rowData.attributeType === 'DateTime'"
              (completeCellEdit)="onRowEditSave(rowData, typeCell)"
              fieldName="dateValue"
              [rowData]="rowData"
              [tableReference]="tableRef"
              [showTime]="rowData.attributeType === 'DateTime'"
            ></jml-lib-date-cell>
          </ng-container>
        </ng-container>
      </td>
      <td class="text-center">
        <div class="flex justify-content-right">
          <button
            pButton
            type="button"
            icon="pi pi-pencil"
            id="editButton{{ rowData.id }}"
            pTooltip="Bearbeiten"
            class="mr-2"
            (click)="openAttributeDialog(rowData)"
          ></button>
          <button pButton type="button" icon="pi pi-trash" (click)="onRowDelete(rowData)" pTooltip="Löschen"></button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
